import React, { useState, useEffect } from 'react';
import logo from '../../assets/logo.png';
import patientImage from '../../assets/BG.png';
import './LoginPage.css';

const SLIDES = [
  {
    titleMain: 'Better Care.',
    titleHighlight: 'Stronger Outcomes.',
    description: 'Empowering patients and care teams with intelligent, real-time remote monitoring for proactive health management and continuous care. Delivering peace of mind through seamless clinical connectivity.'
  },
  {
    titleMain: 'Seamless Connectivity.',
    titleHighlight: 'Continuous Support.',
    description: 'Bridging the gap between clinic and home with real-time biometric tracking, automated compliance reporting, and holistic care management.'
  },
  {
    titleMain: 'Intelligent Monitoring.',
    titleHighlight: 'Instant Clinical Alerts.',
    description: 'Automated anomaly detection and clinical thresholds designed to keep physicians, care coordinators, and patients connected 24/7.'
  }
];

const AuthLayout = ({ title, subtitle, children }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const slideTimer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % SLIDES.length);
    }, 5500);
    return () => clearInterval(slideTimer);
  }, []);

  return (
    <main className="lp-container">
      <div
        className="lp-full-bg"
        style={{ backgroundImage: `url(${patientImage})` }}
        aria-hidden="true"
      />
      <div className="lp-bg-white-overlay" aria-hidden="true" />

      <div className="lp-wide-glass-card">
        <div className="lp-card-left-hero">
          <div className="lp-left-logo-wrap">
            <img src={logo} alt="e-Vitals Remote Patient Monitoring" className="lp-left-logo" />
          </div>

          <div className="lp-carousel-container">
            <div key={currentSlide} className="lp-slide-content">
              <h1 className="lp-title">
                {SLIDES[currentSlide].titleMain}<br />
                <span className="lp-title-highlight">{SLIDES[currentSlide].titleHighlight}</span>
              </h1>
              <p className="lp-description">
                {SLIDES[currentSlide].description}
              </p>
            </div>
          </div>

          <div className="lp-carousel-dots" aria-label="Slide indicators">
            {SLIDES.map((_, idx) => (
              <button
                key={idx}
                type="button"
                className={`lp-dot ${currentSlide === idx ? 'lp-dot-active' : ''}`}
                onClick={() => setCurrentSlide(idx)}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="lp-card-right-form">
          <div className="lp-card-header">
            <h2 className="lp-card-title">{title}</h2>
            {subtitle && <p className="lp-card-subtitle">{subtitle}</p>}
          </div>

          {children}

          <div className="lp-card-footer">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" className="lp-shield-icon">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
            </svg>
            <span>HIPAA Compliant</span>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AuthLayout;
